/**
 * 맵 템플릿 섹션 키 정의
 * - NEW: 신규 또는 추천 맵
 * - FREE/BASIC/PRO: 플랜 타입별 맵
 */
export const SECTION_KEYS = ['NEW', 'FREE', 'BASIC', 'PRO'] as const;

export type SectionKey = (typeof SECTION_KEYS)[number];
